<app-page-heading [heading]="'Add a National Drug'" [tabName]="'national-drugs'"></app-page-heading>

<div *ngIf="isEdit && editNationalDrug.nationalDrugId == null" class="center-container">
  <mat-spinner></mat-spinner>
</div>

<div class="stepper-container">
    <mat-horizontal-stepper #stepper [linear]="true">
        <mat-step [stepControl]="generalFormGroup" [completed]="generalFormGroup.valid">
            <ng-template matStepLabel>General</ng-template>
            <form [formGroup]="generalFormGroup">
                <mat-grid-list cols="2" rowHeight="90px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Regulator</mat-label>
                            <mat-select name="regulator" [formControl]="regulatorFormControl" required>
                                <mat-option *ngFor="let regulator of regulators" [value]="regulator.name">
                                    {{regulator.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-icon class="info-icon" #regulatorTooltip="matTooltip" [matTooltip]="getInfoTooltip('Regulator')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Brand Name</mat-label>
                            <input matInput type="text" [formControl]="brandNameFormControl"  required>
                        </mat-form-field>
                        <mat-icon class="info-icon" #brandNameTooltip="matTooltip" [matTooltip]="getInfoTooltip('Brand Name')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Country</mat-label>
                            <mat-select name="country" [formControl]="countryFormControl" required>
                                <mat-option *ngFor="let country of countries" [value]="country.name" (onSelectionChange)="countrySelected($event)">
                                    {{country.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-icon class="info-icon" #countryTooltip="matTooltip" [matTooltip]="getInfoTooltip('Country')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field class="w-35">
                            <mat-label>Manufacturer</mat-label>
                            <input matInput [formControl]="manufacturerFormControl" type="text"
                                   [matAutocomplete]="manufacturerAuto"
                                   (input)="onInputChangedGetFilteredListOfManufacturers()"
                                   (blur)="blurManufacturer()" required>
                            <mat-autocomplete #manufacturerAuto="matAutocomplete">
                                <mat-option class="custom-mat-option" *ngFor="let manufacturer of manufacturers"
                                            [value]="manufacturer.name"
                                            (onSelectionChange)="manufacturerSelected($event)">
                                    {{manufacturer.name}}
                                </mat-option>
                            </mat-autocomplete>
                            <button *ngIf="manufacturerFormControl.value" matSuffix mat-icon-button
                                    aria-label="Clear" (click)="manufacturerFormControl.reset()">
                                <mat-icon style="color: grey;">clear</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-icon class="info-icon" #manufacturerTooltip="matTooltip"
                                  [matTooltip]="getInfoTooltip('Manufacturer')">help_outline
                        </mat-icon>
                        <button mat-raised-button color="accent" (click)="openManufacturerDialog()"
                                class="add-manufacturer">Add New Manufacturer
                        </button>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>National Drug Code</mat-label>
                            <input matInput type="text" [formControl]="nationalDrugCodeFormControl" required>
                        </mat-form-field>
                        <mat-icon class="info-icon" #nationalDrugTooltip="matTooltip" [matTooltip]="getInfoTooltip('National Drug Code')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Registration Owner</mat-label>
                            <input matInput [formControl]="registrationOwnerFormControl" type="text">
                        </mat-form-field>
                        <mat-icon class="info-icon" #registrationOwnerTooltip="matTooltip" [matTooltip]="getInfoTooltip('Registration Owner')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <greydom-date-picker
                            label="Start Date"
                            [required]="true"
                            [formControl]="startDateFormControl"
                            [tooltip]="getInfoTooltip('Start Date')"
                            [maxDate]="endDateFormControl.value">
                        </greydom-date-picker>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <greydom-date-picker
                            label="End Date" 
                            [required]="true"
                            [formControl]="endDateFormControl"
                            [tooltip]="getInfoTooltip('End Date')"
                            [minDate]="startDateFormControl.value">
                        </greydom-date-picker>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Status</mat-label>
                            <mat-select name="status" [formControl]="statusFormControl" required>
                                <mat-option *ngFor="let status of statuses" [value]="status.name">
                                    {{status.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-icon class="info-icon" #statusTooltip="matTooltip" [matTooltip]="getInfoTooltip('Status')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <greydom-date-picker
                            label="Approval Date"
                            [formControl]="approvalDateFormControl"
                            [tooltip]="getInfoTooltip('Approval Date')">
                        </greydom-date-picker>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Currency</mat-label>
                            <mat-select name="currency" [formControl]="currencyFormControl" required>
                                <mat-option *ngFor="let currency of currencies" [value]="currency.name">
                                    {{currency.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-icon class="info-icon" #currencyTooltip="matTooltip" [matTooltip]="getInfoTooltip('Currency')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Approval Reference</mat-label>
                            <input matInput type="text" [formControl]="approvalReferenceFormControl">
                        </mat-form-field>
                        <mat-icon class="info-icon" #approvalReferneceTooltip="matTooltip" [matTooltip]="getInfoTooltip('Approval Reference')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Origin Reference</mat-label>
                            <input matInput type="text" [formControl]="originReferenceFormControl" required>
                        </mat-form-field>
                        <mat-icon class="info-icon" #originReferenceTooltip="matTooltip" [matTooltip]="getInfoTooltip('Origin Reference')">help_outline</mat-icon>
                    </mat-grid-tile>
                </mat-grid-list>
                <div class="button-container">
                    <button mat-raised-button color="warn" (click)="generalFormGroup.reset()">Clear</button>
                    <button mat-raised-button matStepperNext color="primary" type="button">Next</button>
                </div>
            </form>
        </mat-step>
        <mat-step [completed]="detailFormGroup.valid">
            <ng-template matStepLabel>Detail</ng-template>
            <form [formGroup]="detailFormGroup">
                <mat-grid-list cols="2" rowHeight="90px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Pack Size</mat-label>
                            <input matInput #packSize  type="number" min="0" [formControl]="packSizeFormControl" required>
                        </mat-form-field>
                        <mat-icon class="info-icon" #packSizeTooltip="matTooltip" [matTooltip]="getInfoTooltip('Pack Size')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Drug Name</mat-label>
                            <input matInput type="text" [formControl]="drugNameFormControl" required>
                        </mat-form-field>
                        <mat-icon class="info-icon" #drugNameTooltip="matTooltip" [matTooltip]="getInfoTooltip('Drug Name')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Pack Price ({{currencyFormControl.value}})</mat-label>
                            <input matInput type="number" min="0" [formControl]="packPriceFormControl" required>
                        </mat-form-field>
                        <mat-icon class="info-icon" #packPriceTooltip="matTooltip" [matTooltip]="getInfoTooltip('Pack Price')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Dosage Form</mat-label>
                            <mat-select name="dosageForm" [formControl]="dosageFormFormControl" required>
                                <mat-option *ngFor="let dosageForm of dosageForms" [value]="dosageForm.name">
                                    {{dosageForm.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-icon class="info-icon" #dosageFormTooltip="matTooltip" [matTooltip]="getInfoTooltip('Dosage Form')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="display-field">
                            <p class="label">Individual Price</p>
                            <p>{{calculateIndividualPrice()}} ({{currencyFormControl.value}})</p>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Route of Administration</mat-label>
                            <input matInput type="search" [formControl]="routeOfAdminFormControl" [matAutocomplete]="routeAuto" (input)="onInputChangedFilterRoutes()">
                            <mat-autocomplete #routeAuto="matAutocomplete">
                                <mat-option *ngFor="let route of filteredRoutes" [value]="route.name">
                                    {{route.name}}
                                </mat-option>
                            </mat-autocomplete>
                            <button mat-icon-button matSuffix  (click)="addRoute()">
                                <mat-icon style="color: grey;">add</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-icon class="info-icon" #routeOfAdminTooltip="matTooltip" [matTooltip]="getInfoTooltip('Route of Administration')">help_outline</mat-icon>
                    </mat-grid-tile>
                </mat-grid-list>
                <div formArrayName="routes">
                    <p *ngIf="routes.length < 1" class="form-array error-message">Select at least 1 Route of Admin</p>
                    <div class="form-array" *ngFor="let route of routes.controls; let i=index">
                        <mat-form-field style="width: 20vw">
                            <mat-label>Route {{i + 1}}</mat-label>
                            <input matInput [formControl]="routes.controls[i]" required/>
                            <span matSuffix><a style="cursor: pointer;" (click)="removeRoute(i)"><mat-icon>delete</mat-icon></a></span>
                        </mat-form-field>
                    </div>
                </div>
                <div class="button-container">
                    <button mat-raised-button matStepperPrevious color="primary">Previous</button>
                    <button mat-raised-button color="warn" (click)="detailFormGroup.reset()">Clear</button>
                    <button mat-raised-button color="primary" (click)="detailNext()">Next</button>
                </div>
            </form>
        </mat-step>
        <mat-step [completed]="ingredientsFormGroup.valid">
            <ng-template matStepLabel>Ingredients</ng-template>
            <form [formGroup]="ingredientsFormGroup">
                <mat-grid-list cols="2" rowHeight="90px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Ingredient</mat-label>
                            <input matInput type="search" [formControl]="ingredientFormControl" [matAutocomplete]="ingredientAuto" (input)="onInputChangedFilterIngredients()">
                            <mat-autocomplete #ingredientAuto="matAutocomplete">
                                <mat-option *ngFor="let ingredient of filteredIngredients" [value]="ingredient.name">
                                    {{ingredient.name}}
                                </mat-option>
                            </mat-autocomplete>
                            <button mat-icon-button matSuffix  (click)="addIngredient()">
                                <mat-icon style="color: grey;">add</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-icon class="info-icon" #ingredientTooltip="matTooltip" [matTooltip]="getInfoTooltip('Ingredient')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <p *ngIf="ingredients.length >= 1" class="column-label">Ingredient List:</p>
                        <p *ngIf="ingredients.length < 1" class="column-label error-message">Select at least 1 ingredient</p>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <button style="width: fit-content;" mat-raised-button color="accent" (click)="openIngredientDialog()">Add New Ingredient</button>
                    </mat-grid-tile>
                </mat-grid-list>
                <div>
                    <div formArrayName="ingredients">
                        <div class="form-array" *ngFor="let ingredientGrp of ingredients.controls; let j=index">
                            <ng-container [formGroup]="ingredientGrp">
                                <mat-form-field style="width: 15vw; padding-right: 1vw;">
                                    <mat-label>Ingredient {{j + 1}}</mat-label>
                                    <input matInput formControlName="ingredient" required/>
                                    <span matSuffix><a style="cursor: pointer;" (click)="removeIngredient(j)"><mat-icon>delete</mat-icon></a></span>
                                </mat-form-field>
                                <mat-form-field style="width: 4vw; padding-right: 1vw;">
                                    <mat-label>Strength</mat-label>
                                    <input matInput type="number" min="0" formControlName="strength" required/>
                                </mat-form-field>
                                <mat-form-field style="width: 4vw">
                                    <mat-label>Unit of Measure</mat-label>
                                    <mat-select name="unit" formControlName="unitOfMeasure" required>
                                        <mat-option *ngFor="let unit of unitsOfMeasure" [value]="unit.name">
                                            {{unit.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="button-container">
                    <button mat-raised-button matStepperPrevious color="primary">Previous</button>
                    <button mat-raised-button color="warn" (click)="ingredientsFormGroup.reset()">Clear</button>
                    <button mat-raised-button color="primary" (click)="ingredientNext()">Next</button>
                </div>
            </form>
        </mat-step>
        <mat-step [completed]="mappingFormGroup.valid">
            <ng-template matStepLabel>Mapping</ng-template>
            <form [formGroup]="mappingFormGroup">
                <mat-grid-list cols="2" rowHeight="90px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Master Drug Name</mat-label>
                            <input matInput type="search" [formControl]="masterDrugNameFormControl" [matAutocomplete]="masterDrugAuto" (input)="onInputChangedFilterMasterDrugs()" required>
                            <mat-autocomplete #masterDrugAuto="matAutocomplete">
                                <mat-option *ngFor="let drug of filteredMasterDrugs" [value]="drug.name">
                                  {{drug.name}}
                                </mat-option>
                            </mat-autocomplete>
                            <span matSuffix><mat-icon></mat-icon></span>
                            <button *ngIf="masterDrugNameFormControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="masterDrugNameFormControl.reset()">
                                <mat-icon style="color: grey;">clear</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-icon class="info-icon" #masterDrugNameTooltip="matTooltip" [matTooltip]="getInfoTooltip('Master Drug Name')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile></mat-grid-tile>
                    <mat-grid-tile>
                        <button style="width: fit-content;" mat-raised-button color="accent" (click)="openMasterDrugDialog()">Add New Master Drug</button>
                    </mat-grid-tile>
                </mat-grid-list>
                <div class="button-container">
                    <button mat-raised-button matStepperPrevious color="primary">Previous</button>
                    <button mat-raised-button color="warn" (click)="mappingFormGroup.reset()">Clear</button>
                    <button mat-raised-button matStepperNext color="primary">Next</button>
                </div>
            </form>
        </mat-step>
        <mat-step editable="false">
            <ng-template matStepLabel>Finish</ng-template>
            <mat-grid-list cols="3" rowHeight="80px">
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Brand Name</p>
                        <p class="content">{{brandNameFormControl.value | slice:0:80}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Master Drug Name</p>
                        <p class="content">{{masterDrugNameFormControl.value | slice:0:80}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <a class="link" (click)="openDialog('Ingredients(s)')">Ingredient(s)</a>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Drug Name</p>
                        <p class="content">{{drugNameFormControl.value | slice:0:80}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">National Drug Code</p>
                        <p class="content">{{nationalDrugCodeFormControl.value}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <a class="link" (click)="openDialog('Route(s) of Administration')">Route(s) of Administration</a>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Manufacturer</p>
                        <p class="content">{{manufacturerFormControl.value}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Dosage Form</p>
                        <p class="content">{{dosageFormFormControl.value}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <a class="link" (click)="openDialog('ATC Codes')">ATC Codes</a>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Registration Owner</p>
                        <p class="content">{{registrationOwnerFormControl.value}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label" (click)="openDialog('Pack Size')">Pack Size</p>
                        <p class="content">{{packSizeFormControl.value}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <a class="link" (click)="openDialog('Drug Interactions')">Drug Interactions</a>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Regulator</p>
                        <p class="content">{{regulatorFormControl.value}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Pack Price</p>
                        <p class="content">{{packPriceFormControl.value}} ({{currencyFormControl.value}})</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Status</p>
                        <p class="content">{{statusFormControl.value}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Each Price</p>
                        <p class="content">{{calculateIndividualPrice()}} ({{currencyFormControl.value}})</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Country</p>
                        <p class="content">{{countryFormControl.value}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Currency</p>
                        <p class="content">{{packPriceFormControl.value}} ({{currencyFormControl.value}})</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile></mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Origin Reference</p>
                        <p class="content">{{originReferenceFormControl.value}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Approval Reference</p>
                        <p class="content">{{approvalReferenceFormControl.value}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile></mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Start Date</p>
                        <p class="content">{{startDateFormControl.value | date: dateFormat}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Approval Date</p>
                        <p class="content">{{approvalDateFormControl.value | date: dateFormat}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile></mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">End Date</p>
                        <p class="content">{{endDateFormControl.value | date: dateFormat}}</p>
                    </div>
                </mat-grid-tile>
            </mat-grid-list>
            <div class="button-container">
                <button mat-raised-button matStepperPrevious color="primary">Previous</button>
                <button mat-raised-button matStepperPrevious color="warn" (click)="stepper.reset()">Clear</button>
                <button mat-raised-button color="primary" (click)="finish()">Finish</button>
            </div>
        </mat-step>
    </mat-horizontal-stepper>
</div>
